import { environment as devConfiguration } from 'src/environments/environment.dev';
import { EnvironmentConfig } from 'src/environments/type';

export const environment: EnvironmentConfig = devConfiguration;
